import * as React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import { Alert } from '@mui/material';
import PopUpModal from '../../components/PopupModal';
import UploadImage from '../../components/ImageUpload';

const Register = () => {
  const [seller_profile_name, setName] = useState('');
  const [seller_profile_email, setEmail] = useState('');
  const [seller_profile_number, setNumber] = useState();
  const [seller_profile_alternative_number, setAlternativeNumber] = useState();
  const [seller_profile_address, setAddress] = useState('');
  const [file, setFile] = useState(null);
  const [errors, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();

  const getFile = (f) => {
    setFile(f)
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const newSeller = {
        seller_profile_name, seller_profile_email, seller_profile_number, seller_profile_alternative_number, seller_profile_address
      }
      if (file) {
        const data = new FormData();
        const filename = Date.now() + file.name;
        data.append("name", filename);
        data.append("file", file);
        newSeller.seller_profile_picture = filename;
        try {
          await axios.post(process.env.REACT_APP_FIND_API_URL + "/upload", data);
        } catch (error) {
          console.log(error);
        }
      }
      try {
        const res = await axios.post(process.env.REACT_APP_FIND_API_URL + '/seller/register-seller', newSeller, { withCredentials: true })
        if (res.data) {
          setModal(true)
          setTimeout(() => {
            setModal(false)
          }, 1000);
          setSuccess("Email sent to the registered email!!")
          setError('')
        }
      } catch (error) {
        console.log(error);
        setError("Something went wrong!!")
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className={`d-flex justify-content-center align-items-center py-3`}>
      {<PopUpModal title={success} show={modal} onHide={() => setModal(false)} />}
      <Card style={{ width: '650px' }} className="border-0 py-3">
        <Form onSubmit={handleSubmit}>
          <h1 className="text-center pb-3">Register Your Identity</h1>
          {errors && <div className='text-danger text-center'>{errors}</div>}
          <Row>
            <Col md="6">
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" placeholder="Enter Name" value={seller_profile_name} onChange={(e) => setName(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control type="email" placeholder="Enter email" value={seller_profile_email} onChange={(e) => setEmail(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md="12">
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Address</Form.Label>
                <Form.Control type="text" placeholder="Enter Address" value={seller_profile_address} onChange={(e) => setAddress(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control type="number" placeholder="Enter Phone Number" value={seller_profile_number} onChange={(e) => setNumber(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Alternative Phone Number</Form.Label>
                <Form.Control type="number" placeholder="Enter Phone Number" value={seller_profile_alternative_number} onChange={(e) => setAlternativeNumber(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md="12">
              {
                file &&
                <img className='rounded' width="130px" height="130" alt="img" src={URL.createObjectURL(file)} />
              }
              <UploadImage title="Image" getFile={getFile} />
            </Col>
          </Row>
          <div className='text-end pb-3'>
            <p>Already Have an account ? <Link style={{ color: '#48cae4' }} to={'/login'}>Login</Link></p>
          </div>
          <div>
            <Button variant="primary" type="submit" className="w-100">
              Sign Up
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
}

export default Register;